import axios from "axios";
const { REACT_APP_SGI_URL } = process.env;

async function getCard() {
  const res = await axios.get("/my-tim");
  return res.data;
}

async function getCardInfo(tim?: string) {
  const res = await axios.get(`/my-tim/cards/${tim}`);
  return res.data;
}

async function getWalletOperations(page?: number, resultsPerPage?: number, language?: string) {
  const res = await axios.get(
    `${process.env.REACT_APP_WALLET_URL}/my-wallet/operations`,
    { headers: 
      {
        'resultsPerPage': resultsPerPage || 10,
        'page': page || 1,
        'Accept-Language': language + '-ES' || 'ca-ES'
      }
    }
  );

  return { data: res.data, headers: res.headers };
}

async function completeCardInfo(tim: any) {
  const res = await axios.post(`/my-tim/complete-card`, tim);
  return res.data;
}

async function getClaims() {
  const res = await axios.get(`${REACT_APP_SGI_URL}/my-claims`);
  return res.data;
}

export const MyTimApi = {
  getCard,
  getCardInfo,
  completeCardInfo,
  getWalletOperations,
  getClaims
};
